import React, { useEffect, useState } from "react";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import "./style.css";

const ReusableGrid = ({
  rowData,
  columnDefs,
  height=350,
  width = "100%",
  defaultColDef = {
    sortable: true,
    minWidth: 120,
    maxWidth: 180,
    resizable: true
  },
  gridRef,
  onSelectionChanged,
  pagination = true,
  domLayout,
  pageSize = 10
}) => {
  const [gridApi, setGridApi] = useState(null);

  const onGridReady = (params) => {
    gridRef.current = params.api;
    setGridApi(params.api);
    params.api.sizeColumnsToFit();
  };

  // ⬇️ React to external pageSize prop change
  useEffect(() => {
    if (gridApi) {
      if (gridApi.setPaginationPageSize) {
        gridApi.setPaginationPageSize(pageSize);
      } else if (gridApi.paginationSetPageSize) {
        gridApi.paginationSetPageSize(pageSize);
      }
    }
  }, [pageSize, gridApi]);

  return (
    <div
      className="ag-theme-alpine"
      style={{
        height: height, // 160px is example header/footer combined height
        width: width,
        display: "flex",
        flexDirection: "column",
        overflow: "hidden"
      }}
    >
      <div style={{ flex: 1, overflow: "auto" }}>
        <AgGridReact
          ref={gridRef}
          rowData={rowData}
          columnDefs={columnDefs}
          defaultColDef={defaultColDef}
          animateRows
          rowHeight={40}
          headerHeight={40}
          rowSelection="multiple"
          suppressRowClickSelection
          domLayout={domLayout || "normal"}
          onGridReady={onGridReady}
          onSelectionChanged={(event) => {
            const selected = event.api.getSelectedRows();
            if (onSelectionChanged) {
              onSelectionChanged(selected);
            }
          }}
          pagination={pagination}
          paginationAutoPageSize={false}
          paginationPageSize={pageSize}
        />
      </div>
    </div>
  );
};

export default ReusableGrid;
